import React, { useMemo } from 'react';
import { EventType, IEvent } from '~/Models/DTO/Event.model';
import { selectLocationById, selectTrainerById } from '~/store/provider';
import { selectBookingSummaryForEvent } from '~/store/bookings';
import { Navigate, useLanguage, useNavigation } from '~/Hooks';
import { Route } from '~/Constants/Routes.constants';
import { useSelector } from 'react-redux';
import { makeStyles } from '~/UIKit/Style';
import { FONT_SIZE_SMALL } from '~/Constants/UI.constants';

export const useStyles = makeStyles(() => ({
  trainer: {
    fontSize: FONT_SIZE_SMALL,
  },
}));

const goToDetailCallback = (navigate: Navigate, id: string, eventType: string) => () =>
  navigate(Route.EVENT_DETAILS, { id, eventType });

export const useCalendarListItem = (event: IEvent) => {
  const { t } = useLanguage();
  const { classes } = useStyles();
  const trainer = useSelector(selectTrainerById(event.trainerIds[0]));
  const location = useSelector(selectLocationById(event.locationId));
  const bookingInformation = useSelector(selectBookingSummaryForEvent(event.id));
  const { navigate } = useNavigation();
  const eventDetails = useMemo(() => {
    const locationName = location?.name || '';
    if (event.type === EventType.FREE_TRAINING) {
      return `${t('event.freeTraining')} · ${locationName}`;
    }

    return (
      <>
        {trainer?.name && <span className={classes.trainer}>{trainer.name}</span>} · {locationName}
      </>
    );
  }, [event, location, trainer]);
  const isTimeVisible = useMemo(() => ![EventType.FREE_TRAINING].includes(event.type), [event]);

  return {
    location,
    goToDetails: goToDetailCallback(navigate, event.id, event.type),
    eventDetails,
    isTimeVisible,
    bookingInformation,
  };
};
